A position profile in a paginated list.
